var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTickCircle = function SvgTickCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m10.357 5.285-3.39 3.394-1.355-1.358a.96.96 0 0 0-1.356 0 .96.96 0 0 0 0 1.357l2.034 2.036a.96.96 0 0 0 1.356 0l4.067-4.072a.96.96 0 0 0 0-1.357.96.96 0 0 0-1.356 0M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 14A6 6 0 0 1 8 2a6 6 0 0 1 0 12"
  })));
};
export default SvgTickCircle;